<template>
  <div>
    <div class="parse-file">
      <div class="alert alert-danger" v-if="error">{{ error }}</div>
      <div
        v-if="!file"
        :class="['dropzone-area', dragging ? 'dropzone-over' : '']"
        drag-over="handleDragOver"
        @dragenter="dragging = true"
        @dragleave="dragging = false"
      >
        <div class="dropzone-text flex items-center  flex-col text-tile">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12"
            viewBox="0 0 256 256"
          >
            <path
              fill="currentColor"
              d="M200 28H72a12 12 0 0 0-12 12v28H40a12 12 0 0 0-12 12v96a12 12 0 0 0 12 12h20v28a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12V40a12 12 0 0 0-12-12m-44 72h48v56h-48Zm48-60v52h-48V80a12 12 0 0 0-12-12h-4V36h60a4 4 0 0 1 4 4M68 40a4 4 0 0 1 4-4h60v32H68ZM36 176V80a4 4 0 0 1 4-4h104a4 4 0 0 1 4 4v96a4 4 0 0 1-4 4H40a4 4 0 0 1-4-4m32 40v-28h64v32H72a4 4 0 0 1-4-4m132 4h-60v-32h4a12 12 0 0 0 12-12v-12h48v52a4 4 0 0 1-4 4M68.93 149.44L86.79 128l-17.86-21.44a4 4 0 0 1 6.14-5.12L92 121.75l16.93-20.31a4 4 0 1 1 6.14 5.12L97.21 128l17.86 21.44a4 4 0 1 1-6.14 5.12L92 134.25l-16.93 20.31A4 4 0 0 1 72 156a3.94 3.94 0 0 1-2.56-.93a4 4 0 0 1-.51-5.63"
            />
          </svg>

          <span class="dropzone-title">{{ text[lang].file.select }}</span>
          <span class="dropzone-info" v-if="help">{{ help }}</span>
        </div>
        <input type="file" @change="upload" />
      </div>
      <div class="dropzone-preview" v-else></div>
    </div>
  </div>
</template>

<script>
import parseFile from "../parser";
import text from "../lang";
import EventBus from "../../../Ui/EventBus";
export default {
  name: "ParseFile",
  props: {
    help: {
      type: String,
    },
    lang: {
      type: String,
      default: () => "en",
    },
  },
  methods: {
    upload(event) {
      this.$parent.$emit("loading", true);
      this.loading = true;

      const files = event.target.files || event.dataTransfer.files;
      if (files.length !== 1) {
        this.error = text[this.lang].error.fileSelection;
        return;
      }
      this.file = event.target.files[0]; 
      parseFile(this.file, text[this.lang])
        .then((results) => {
          this.error = null;

          this.$emit("fileDataReceived", results);
          this.$emit("fileNameReceived", files[0].name);
        })
        .catch((error) => {
          this.error = error;
          this.file = null;
        })
        .finally(() => {
          this.$parent.$emit("loading", false);
          this.loading = false;
        });
    },
    reset() {
      this.$parent.$emit("loading", true);
      this.$emit("FileRemove", "true");
      this.error = null;
      this.file = null;
    },
    updateProgress(oEvent) {
      console.log("oEvent", oEvent);
    },
  },
  mounted() {
    EventBus.$on("fileResetExcel", () => {
      this.reset();
    });

    var oReq = new XMLHttpRequest();

    oReq.addEventListener("progress", this.updateProgress);
  },
  data() {
    return {
      error: null,
      dragging: false,
      loading: false,
      file: null,
      text,
    };
  },
};
</script>

<style scoped>
.dropzone-over {
  border: 1px solid red !important;
}

.dropzone-area {
  height: 200px;
  position: relative;
}

.dropzone-area .dropzone-title {
  @apply text-tile;
}

.dropzone-area input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropzone-text {
  position: absolute;
  top: 50%;
  text-align: center;
  transform: translate(0, -50%);
  width: 100%;
}

.dropzone-text span {
  display: block;
  line-height: 1.9;
}

.dropzone-title {
  font-size: 13px;
  color: #787878;
  letter-spacing: 0.4px;
}

.dropzone-info {
  font-size: 12px;
  color: #a8a8a8;
  letter-spacing: 0.4px;
}

.dropzone-button {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}
</style>
